import { IPayoutSettingsResponse } from "@wingspanhq/payments/dist/interfaces";

export const selectorInstantPayoutDefaultFee = (
  payoutSettings?: IPayoutSettingsResponse
) => (payoutSettings?.instantPayoutSettings.feePercentage ?? 0.01) * 100;
